export default __webpack_public_path__ + "static/media/image-behaviour-1.e4cf9970.png";